import React from "react";
import { Link } from "react-router-dom";
import { salesImportBranchDisplayName } from "../config/salesImportBranchIds";
import { useSalesImportBranchFilter } from "../hooks/useSalesImportBranchFilter";

const TABS = [
  { key: "import", to: "/sales-data-import", label: "Import", exact: true },
  { key: "history", to: "/sales-data-import/history", label: "Upload History" },
  { key: "records", to: "/sales-data-import/records", label: "View Records" },
  { key: "voucher-list", to: "/sales-data-import/voucher-list", label: "Voucher List" },
  { key: "advanced-reports", to: "/sales-data-import/advanced-reports", label: "Advanced Reports" },
  { key: "branch-monthly", to: "/sales-data-import/branch-monthly", label: "Branch Monthly" },
  { key: "brand-by-branch", to: "/sales-data-import/brand-by-branch", label: "Brand by Branch" },
  { key: "group-by-branch", to: "/sales-data-import/group-by-branch", label: "Group by Branch" },
  { key: "discount-sales", to: "/sales-data-import/discount-sales", label: "Discount Sales" },
  { key: "items-on-sale", to: "/sales-data-import/items-on-sale", label: "Items on Sale" },
  { key: "branch-voucher-reports", to: "/sales-data-import/branch-voucher-reports", label: "Branch Vouchers" },
];

export default function SalesImportNav({ active, showBranchFilter = true }) {
  const { branchId, setBranchId, branchOptions } = useSalesImportBranchFilter();

  return (
    <div className="sdic-nav-bar">
      <nav className="sdic-nav-tabs">
        {TABS.map((tab) =>
          tab.key === active ? (
            <span key={tab.key} className="sdic-btn sdic-btn-primary">
              {tab.label}
            </span>
          ) : (
            <Link key={tab.key} to={tab.to} className="sdic-btn sdic-btn-secondary">
              {tab.label}
            </Link>
          )
        )}
      </nav>
      {showBranchFilter && (
        <label className="sdic-nav-branch">
          Branch
          <select value={branchId} onChange={(e) => setBranchId(e.target.value)}>
            <option value="all">All branches</option>
            {branchOptions.map((b) => (
              <option key={b} value={b}>
                {salesImportBranchDisplayName(b)}
              </option>
            ))}
          </select>
        </label>
      )}
    </div>
  );
}
